<template>
  <div class="hidden md:flex justify-between w-full mt-2">
    <Button
      v-if="props.content.nextPrevSlug?.prevSlug"
      :label="$t('common.previous')"
      :left-icon-name="IconName.ARROW_LEFT_CIRCLE"
      :variant="ButtonVariant.TEXT"
      :color="ButtonColor.SECONDARY"
      :to="`/${hubSlug}/${props.content.nextPrevSlug.prevSlug}`"
    />
    <Button
      v-if="props.content.nextPrevSlug?.nextSlug"
      :label="$t('common.next')"
      :right-icon-name="IconName.ARROW_RIGHT_CIRCLE"
      :variant="ButtonVariant.TEXT"
      :color="ButtonColor.SECONDARY"
      :to="`/${hubSlug}/${props.content.nextPrevSlug?.nextSlug}`"
    />
  </div>
  <div
    class="md:hidden flex gap-2 fixed bottom-0 left-0 bg-surface w-full px-5 py-3 z-40"
  >
    <Button
      v-if="props.content.nextPrevSlug?.prevSlug"
      :label="$t('common.previous')"
      :left-icon-name="IconName.ARROW_LEFT_CIRCLE"
      :variant="ButtonVariant.OUTLINED"
      :color="ButtonColor.SECONDARY"
      block
      :to="`/${hubSlug}/${props.content.nextPrevSlug.prevSlug}`"
    />
    <Button
      v-if="props.content.nextPrevSlug?.nextSlug"
      :label="$t('common.next')"
      :right-icon-name="IconName.ARROW_RIGHT_CIRCLE"
      :variant="ButtonVariant.OUTLINED"
      :color="ButtonColor.SECONDARY"
      block
      :to="`/${hubSlug}/${props.content.nextPrevSlug.nextSlug}`"
    />
  </div>
</template>
<script lang="ts" setup>
import { Button, ButtonColor, ButtonVariant, IconName } from '@exfluential/ui';
import { ContentDto } from '~/api/contents';

type Props = {
  hubSlug: string;
  content: ContentDto;
};

const props = defineProps<Props>();
</script>
